export default __webpack_public_path__ + "static/media/ic-notification-bell-selected.7495104e.svg";